<div class="card ui-g-12">
    <div class="ui-g-12" *ngIf="this.base_url===this.userTypes['DOCTOR'] && this.is_primary_provider">
        <span style="padding-left: 6px;">
            <button pButton type="button" label="Get Link" class="ui-button-info ui-button-rounded"
                (click)="referralLinkDialog=true"
                style=" margin-top: 5px;float:right;padding-left:5px;color: #004aad;background-color: #FFFFFF"></button>
        </span>
    </div>
    <div class="ui-g-12">
        <p-dataView #dv [value]="profile_card_data" [paginator]="true" [rows]="16" filterBy="name,occupation,country"
            [sortField]="sortField" [sortOrder]="sortOrder" layout="grid">

            <!-- <ng-template pTemplate="p-header"> -->
            <p-header>
                <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                    <!-- <div class = "ui-g-12"> -->
                    <p-dropdown [options]="profiles_type_data" [(ngModel)]="profiles_type"
                        placeholder="Select Professional Type" (onChange)="onProfessionalChange()"
                        styleClass="p-mb-2 p-mb-md-0" [ngStyle]="{'padding-right':'1%'}"></p-dropdown>
                    <p-dropdown [options]="sortOptions" [(ngModel)]="sortKey" placeholder="Sort Doctors By"
                        (onChange)="onSortChange($event)" styleClass="p-mb-2 p-mb-md-0"></p-dropdown>
                    <span class="p-input-icon-left p-mb-2 p-mb-md-0" style="padding-left: 20px;">

                        <input type="search" pInputText placeholder="Search by Occupation, Name" style="width:25%;"
                            (input)="dv.filter($event.target.value)">
                    </span>
                    <span class="p-input-icon-left p-mb-2 p-mb-md-0" style="padding-left: 20px;">

                        <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
                    </span>

                    <!-- </div> -->
                </div>
            </p-header>
            <!-- </ng-template> -->

            <ng-template let-row pTemplate="listItem">
                <div class="p-col-12">

                    <div class="product-list-item">
                        <div class="product-list-detail">
                            <img [src]="row.avatar_url==null || (row.avatar_url!=null && row.avatar_url.length==0)?'./assets/images/default_profile.jpg':row.avatar_url"
                                style="width: 150px;" class="img-fluid " [alt]="row.name" class="doc-pic">
                        </div>

                        <div class="product-list-detail">
                            <div class="product-name">
                                Name:{{row.name}}
                            </div>
                            <!-- <div class="product-name">Degree: {{doctor.degree}}</div> -->
                            <div class="product-description" *ngIf="profiles_type==0">
                                Speciality: {{row.occupation}}
                            </div>
                            <div class="product-name">
                                Country: {{row.country}}
                            </div>
                        </div>

                        <div class="product-list-action">
                            <button pButton type="button" label="View Profile" class="ui-button-info ui-button-rounded"
                                (click)="GetProfileData(row.user_guid)">
                            </button>
                        </div>
                    </div>
                </div>


            </ng-template>



            <ng-template let-row pTemplate="gridItem">
                <div class="p-col-12 p-md-4">
                    <!-- <div class="product-grid-item card"> -->
                    <div class="ui-g ui-fluid">
                        <div class="ui-g-12 ui-md-4">
                            <!-- <div class="product-grid-item-content"> -->
                            <div class="flip">
                                <div class="front">
                                    <div class="product-grid-item card">
                                        <img [src]="row.avatar_url==null || (row.avatar_url!=null && row.avatar_url.length==0)?'./assets/images/default_profile.jpg':row.avatar_url"
                                            style="width: 150px; height: 150px;" class="img-fluid " [alt]="row.name"
                                            class="doc-pic">
                                        <div class="product-name" style="color:black">
                                            {{row.name}}
                                        </div>
                                        <!-- <div class = "product-name"> {{doctor.degree}}</div> -->
                                        <div class="product-description" *ngIf="profiles_type==0">
                                            {{row.occupation}}
                                        </div>
                                        <div class="product-name" style="color:black">
                                            {{row.country}}
                                        </div>

                                    </div>
                                </div>
                                <div class="back">
                                    <div class="product-grid-item card">
                                        <!-- <h2>Residence</h2>
                                        <div class="product-description"> {{doctor.egd_users.country.country_name}}</div> -->
                                        <div class="product-description"> <button pButton type="button"
                                                label="View Profile" class="ui-button-info ui-button-rounded"
                                                style="margin-top:6em; padding:0.5em;"
                                                (click)="GetProfileData(row.user_guid)">
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>

        </p-dataView>
    </div>
</div>


<div *ngIf="this.DoctorProfileDialogVisible">
    <p-dialog header="Doctor Profile" [resizable]="false" responsive="true" (onHide)="CloseDoctorProfileDialog()"
        [(visible)]="this.DoctorProfileDialogVisible">
        <app-shared-profile [user_guid]="user_guid" (dialogChange)="close($event)"></app-shared-profile>
    </p-dialog>
</div>

<div *ngIf="this.OtherMedicalProfileDialogVisible">
    <p-dialog header="Other Medical Professional Profile" [resizable]="false" responsive="true"
        (onHide)="CloseOtherMedicalProfileDialog()" [(visible)]="this.OtherMedicalProfileDialogVisible">
        <app-other-medical-profe-shared-profile [user_guid]="user_guid" (dialogChange)="close($event)">
        </app-other-medical-profe-shared-profile>
    </p-dialog>
</div>




<p-dialog *ngIf="referralLinkDialog" header="Get your Referral Link" [resizable]="false" responsive="true"
    [(visible)]="referralLinkDialog" (onHide)="referralLinkDialog=false">
    <div class="clip"  pTooltip="Click to copy this link"
        tooltipPosition="top" (click)="CopyLink()">
        <div>
            <p style="margin:1%;">{{link}}</p>

        </div>
        <div>
            <p>
                <i class="pi pi-copy" style="font-size: 1.5rem;"></i>
            </p>
        </div>
    </div>
    <div style="text-align: center;" *ngIf="response.success!=null && response.success && copied_response">
        <p>Link has been copied!</p>
    </div>

   
</p-dialog>